export function extractNamespace(url?: string): string {
  if (!url) return 'unknown'
  const path = url.replace(/^https?:\/\/[^/]+/, '')
  const clean = path.split('?')[0]

  // Remove numeric path segments (path params)
  return clean
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .filter((seg) => !/^\d+$/.test(seg))
    .join('.')
}
